import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {MessageService} from 'primeng/api';

@Component({
    providers: [MessageService],
    selector: 'card',
    template: `
        <div class="info-card mr-4">
            <div class="flex flex-space-between">
                <div class="card-header">{{header}}</div>
                <img src="{{iconPath}}" alt="" />
            </div>
            <div class="card-amount mt-2">{{amount}}</div>
            <div class="card-sub-amount">{{subAmount}}</div>
            <div class="card-last-update mt-2">{{lastUpdate}}</div>
        </div>
    `
})
export class CardComponent implements OnInit {

    @Input()
    public header: string = '';

    @Input()
    public amount: string = '';

    @Input()
    public subAmount: string = '';

    @Input()
    public lastUpdate: string = '';

    @Input()
    public iconPath: string = '';

    @Output()
    public cardChange = new EventEmitter<any[]>();

    constructor(
        private messageService: MessageService) {
    }

    ngOnInit(): void {

    }

    onChange(event: any) {
        this.cardChange.emit();
        event?.originalEvent?.stopPropagation();
    }

}
